import React from 'react';
import {Icons, Images} from '../../../assets';

type PublicShellProps = {
  children: React.ReactNode;
  onLogout: () => void;
};

export const PublicShell: React.FC<PublicShellProps> = ({children, onLogout}) => {
  return (
    <div className="min-h-screen bg-[#F5F6FB] flex">
      <aside className="h-screen bg-gray-100 fixed left-0 top-0 flex flex-col justify-between items-center z-50 w-20 pb-5">
        <div className="w-14 h-14 p-2.5 flex justify-center items-center mt-5">
          <img className="w-12 h-12 object-contain" src={Images.LOGO} alt="Recco Logo" />
        </div>
        <div className="flex flex-col justify-start items-center gap-4 mb-5">
          <button onClick={onLogout} title="Sign Out" className="transition-opacity hover:opacity-70">
            <img src={Icons.LOGOUT_SIGN_OUT} alt="Sign Out" />
          </button>
        </div>
      </aside>
      <main className="ml-20 flex-1 px-10 bg-white pb-12 pt-10">{children}</main>
    </div>
  );
};
